import type { MatchEvents, Player, PlayerStats } from 'modules/client/tournaments/domain/types';

const emptyStats = {
  goals: 0,
  assists: 0,
  redCards: 0,
  appearances: 0,
  yellowCards: 0,
};

function calculatePlayersStats(players: Player[], matchEvents: MatchEvents[]): Player[] {
  const stats = {} as Record<number, PlayerStats>;

  // Счётчики читаем и заводим через одну карту: при двух отдельных копиях гол и пас,
  // записанные по ошибке на одного игрока, затирали бы друг друга.
  const statsOf = (userId: number): PlayerStats => {
    const current = stats[userId] ?? { ...emptyStats };
    stats[userId] = current;
    return current;
  };

  for (const event of matchEvents) {
    if (!event.userId || !event.type) {
      continue;
    }

    switch (event.type) {
      case 'goal':
      case 'corner':
      case 'penalty':
        if (event.secondaryUserId) {
          // Контракт события: `user` — пасующий, `secondaryUser` — забивающий
          // (`shared/types/match-event.ts`).
          statsOf(event.userId).assists += 1;
          statsOf(event.secondaryUserId).goals += 1;
        } else {
          statsOf(event.userId).goals += 1;
        }
        break;
      case 'redcard':
        statsOf(event.userId).redCards += 1;
        break;
      case 'yellowcard':
        statsOf(event.userId).yellowCards += 1;
        break;
    }
  }

  return players.map((player) => {
    return { ...player, ...stats[player.id] };
  });
}

export default calculatePlayersStats;
